import React from 'react';
import { Section } from './ui/Section';
import { AlertTriangle, Clock, Pill, ShieldAlert } from 'lucide-react';
export function Problem() {
  const errors = [{
    icon: <ShieldAlert className="w-8 h-8 text-terracotta" data-id="element-142" />,
    title: 'Mezclan suplementos que compiten entre sí',
    desc: '(anulando su efecto).'
  }, {
    icon: <Clock className="w-8 h-8 text-terracotta" data-id="element-143" />,
    title: 'Los toman en horarios incorrectos',
    desc: 'donde el cuerpo no los puede absorber.'
  }, {
    icon: <Pill className="w-8 h-8 text-terracotta" data-id="element-144" />,
    title: 'Compran opciones baratas',
    desc: 'llenas de rellenos sintéticos que el hígado no reconoce.'
  }];
  return <Section bg="cream-dark" data-id="element-145">
      <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-146">
        <AlertTriangle className="w-12 h-12 text-terracotta mx-auto mb-6" data-id="element-147" />
        <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-148">
          El mercado de suplementos es una selva.
        </h2>
        <p className="text-xl text-charcoal-light" data-id="element-149">
          Miles de marcas, cientos de promesas y etiquetas que parecen estar
          escritas en otro idioma. La mayoría de las personas cometen estos{' '}
          <strong className="text-terracotta" data-id="element-150">3 errores graves</strong>:
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-151">
        {errors.map((error, idx) => <div key={idx} className="bg-white p-8 rounded-2xl shadow-sm border border-sage-100 flex flex-col items-center text-center relative overflow-hidden group hover:shadow-md transition-shadow" data-id="element-152">
            <div className="absolute top-0 left-0 w-full h-1 bg-terracotta/20 group-hover:bg-terracotta transition-colors" data-id="element-153"></div>
            <div className="bg-cream-dark p-4 rounded-full mb-6" data-id="element-154">
              {error.icon}
            </div>
            <h3 className="text-xl font-bold mb-2" data-id="element-155">{error.title}</h3>
            <p className="text-charcoal-light" data-id="element-156">{error.desc}</p>
          </div>)}
      </div>

      <div className="mt-16 text-center max-w-2xl mx-auto bg-terracotta/10 p-6 rounded-xl border border-terracotta/20" data-id="element-157">
        <p className="text-xl font-medium text-terracotta-dark" data-id="element-158">
          El resultado es el mismo: Cero cambios en tu energía y mucho dinero
          desperdiciado.
        </p>
      </div>
    </Section>;
}